import axiosInstance from '../axios/axiosInstance';
import { AuthenticationRequest, RefreshRequest, RegisterRequest } from '../model/request';
import { AuthenticationResponse } from '../model/response';

export const register = async (registerRequest: RegisterRequest) => {
  const { data } = await axiosInstance.post<AuthenticationResponse>('auths/register', registerRequest);
  return data;
};

export const authenticate = async (authenticationRequest: AuthenticationRequest) => {
  const { data } = await axiosInstance.post<AuthenticationResponse>('auths/authenticate', authenticationRequest);
  return data;
};

export const refreshToken = async (refreshRequest: RefreshRequest) => {
  const { data } = await axiosInstance.post<AuthenticationResponse>('auths/refreshToken', refreshRequest);
  return data;
};
